import { useSignForm } from '@shared/components/forms/sign'
import { getInitialValues } from '@shared/components/forms/sign/steps/step2/form/initial-values'
import { useFormik } from 'formik'

import { sendStep2SignForm } from './api'
import { Step2FormModel } from './model'
import { step2ValidationSchema } from './validation.schema'
import { View } from './view'

export const SignFormStep2 = () => {
	const { nextStep, consentTypes, optionalDocsIds } = useSignForm()

	const formik = useFormik<Step2FormModel>({
		initialValues: getInitialValues(consentTypes.ids),
		validationSchema: step2ValidationSchema,
		validateOnChange: true,
		isInitialValid: false,
		enableReinitialize: true,

		async onSubmit(values, { setSubmitting, resetForm, setStatus }) {
			setStatus('')
			setSubmitting(true)

			try {
				const response = await sendStep2SignForm(
					values.code,
					Object.entries(optionalDocsIds)
						.filter(([, value]) => value)
						.map(([id]) => id)
				)

				if (!(response as any)?.verified) {
					throw new Error('wrong_code')
				}

				nextStep()
			} catch (error: any) {
				resetForm({ status: error?.message })
				setSubmitting(false)
			}
		},
	})

	return View({
		formik,
	})
}
